import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

import Page from '../component/Page/Page'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import InventoryDetailBox from './components/InventoryDetailBox'
import Box from '../component/Box/Box'
import ProductTypeSelector, { mapItems } from '../productType/component/ProductTypeSelector'
import CustomGrid from '../customGrid/CustomGrid'
import InventoryItemsGrid from '../customGrid/entities/InventoryItemsGrid'
import InventoryItemsStatusSelector from './components/InventoryItemsStatusSelector'
import ProductTypeService from '../productType/ProductTypeService'
import Notify from '../services/Notify'
import IntentoryItemsHeaderCustom from './components/inventoryItemSHeaderCustom'

const inventoryItemsMetadata = new InventoryItemsGrid()
const productTypeService = new ProductTypeService()

function InventoryItemsScreen({ match, history }) {
  const [productType, setProductType] = useState(null)
  const [productTypeIdFilter, setProductTypeIdFilter] = useState()
  const [inventoryItemStatusFilter, setInventoryItemStatusFilter] = useState(null)
  const [params, setParams] = useState(null)
  const [inventoryItemExpectedItemFilter, setInventoryItemExpectedItemFilter] = useState(false)

  const { inventoryId } = match.params

  const handleSetParams = () => {
    const urlSearchParams = new URLSearchParams({})

    if (inventoryItemStatusFilter && inventoryItemStatusFilter.length > 0) {
      inventoryItemStatusFilter.forEach(x => {
        urlSearchParams.append('status', x.value)
      })
    }
    productTypeIdFilter && urlSearchParams.append('productTypeId', productTypeIdFilter)
    inventoryItemExpectedItemFilter && urlSearchParams.append('onlyExpected', inventoryItemExpectedItemFilter)

    setParams(urlSearchParams.toString())
  }

  const handleSetInventoryStatusItem = (item) => {
    setInventoryItemStatusFilter(item)
  }

  const handleSetInventoryItemOnlyExpected = (item) => {
    setInventoryItemExpectedItemFilter(!inventoryItemExpectedItemFilter);
  }

  const getProductType = async (productTypeId) => {
    try {
      const productTypeEntity = await productTypeService.findById(productTypeId)
      setProductType(productTypeEntity)
    } catch (error) {
      Notify.error('Houve um erro ao buscar o tipo de produto', error)
    }
  }

  const setSearchParams = () => {
    const searchParams = new URLSearchParams(history.location.search).entries()

    for (var [property, value] of searchParams) {
      switch (property) {
        case 'productType':
          setProductTypeIdFilter(value)
          getProductType(value)
          break;
        default:
          break;
      }
    }
  }

  useEffect(() => {
    !productTypeIdFilter && setProductType(null)
    handleSetParams()
  }, [productTypeIdFilter, inventoryItemStatusFilter, inventoryItemExpectedItemFilter])

  useEffect(() => {
    setSearchParams()
  }, [])

  return (
    <Page
      headerCustom={
        <IntentoryItemsHeaderCustom endpoint={inventoryItemsMetadata.endpoint(inventoryId,params)} />
      }
      breadcrumbs={[
        <BreadcrumbItem key={1} title="Lista de inventários" to="/list/inventories" />,
        <BreadcrumbItem key={2} title="Detalhes do inventário" to={`/inventories/${inventoryId}`} />,
        <BreadcrumbItem key={3} title="Itens do inventário" />,
      ]}
    >
      <InventoryDetailBox inventoryId={inventoryId} />
      <Box title="Produtos">
        <Row className="mb-3">
          <Col md={4}>
            <ProductTypeSelector setValue={setProductTypeIdFilter} defaultValue={productType && mapItems(productType)} />
          </Col>
          <Col md={4}>
            <InventoryItemsStatusSelector multiple setValue={handleSetInventoryStatusItem} value={inventoryItemStatusFilter} />
          </Col>
        </Row>
        <CustomGrid
          removeBox
          metadata={inventoryItemsMetadata}
          endpoint={inventoryItemsMetadata.endpoint(inventoryId, params)}
        />
      </Box>
    </Page>
  )
}

export default InventoryItemsScreen



// WEBPACK FOOTER //
// ./src/Inventory/InventoryItemsScreen.js